<template>
  <div id="assetEdit">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            資產資料{{ $route.query.assetId ? '編輯' : '新增' }}
          </div>
          <div class="tip">
            可在此編輯、上傳設備資料
          </div>
        </div>
        <div class="right">
          <span class="tips">*為必填</span>
        </div>
      </div>
      <div class="blockWrap">
        <el-form
          ref="assetData"
          class="list"
          :model="assetData"
          status-icon
          label-position="left"
          :rules="rule"
        >
          <div class="form-title-wrap">
            <div class="form-title">
              設備資料
            </div>
            <div class="form-tip">
              記錄資產設備基本資料，須下載預設表單編輯後，上傳資料
            </div>
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="設備財編">
                <el-input
                  v-model="assetData.AssetSn"
                  placeholder="請輸入設備財編"
                  :disabled="pageType === 'view'"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="設備名稱"
                prop="AssetName"
              >
                <el-input
                  v-model="assetData.AssetName"
                  placeholder="請輸入設備名稱"
                  maxlength="20"
                  :disabled="pageType === 'view'"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="設備類別">
                <el-cascader
                  v-model="selectedCategory"
                  style="display: block"
                  :options="categoryList"
                  :props="{ checkStrictly: true }"
                  clearable
                  :disabled="pageType === 'view'"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="設備狀態"
                prop="StatusId"
              >
                <el-select
                  v-model="assetData.StatusId"
                  placeholder="請選擇"
                  :disabled="pageType === 'view'"
                >
                  <el-option
                    v-for="item in statusList"
                    :key="item.Id"
                    :label="item.StatusDesc"
                    :value="item.Id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="區域">
                <el-select
                  v-model="assetData.AreaId"
                  placeholder="請選擇"
                  :disabled="pageType === 'view'"
                >
                  <el-option
                    v-for="item in areaList"
                    :key="item.Id"
                    :label="item.Name"
                    :value="item.Id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="廠牌">
                <el-input
                  v-model="assetData.BrandName"
                  placeholder="請輸入廠牌"
                  maxlength="50"
                  :disabled="pageType === 'view'"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="型號">
                <el-input
                  v-model="assetData.ModelNo"
                  placeholder="請輸入型號"
                  maxlength="50"
                  :disabled="pageType === 'view'"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="產品序號">
                <el-input
                  v-model="assetData.ProductSn"
                  placeholder="請輸入產品序號"
                  maxlength="50"
                  :disabled="pageType === 'view'"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="購置金額">
                <el-input
                  v-model.number="assetData.PurchaseAmount"
                  type="number"
                  placeholder="請輸入購置金額"
                  :disabled="pageType === 'view'"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="耐用年限">
                <el-input
                  v-model.number="assetData.UsefulLife"
                  type="number"
                  placeholder="請輸入耐用年限"
                  :disabled="pageType === 'view'"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="購買日期">
                <el-date-picker
                  v-model="assetData.PurchaseDate"
                  value-format="yyyy-MM-dd"
                  format="yyyy/MM/dd"
                  type="date"
                  placeholder="選擇購買日期"
                  :disabled="pageType === 'view'"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="保固到期日">
                <el-date-picker
                  v-model="assetData.WarrantyExpirationDate"
                  value-format="yyyy-MM-dd"
                  format="yyyy/MM/dd"
                  type="date"
                  placeholder="選擇保固到期日"
                  :disabled="pageType === 'view'"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="備註">
                <el-input
                  v-model="assetData.Note"
                  type="textarea"
                  maxlength="200"
                  :disabled="pageType === 'view'"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <template v-if="$route.query.assetId">
            <div class="form-title-wrap">
              <div class="form-title">長期修繕計畫&amp;費用(由維養計畫匯入)</div>
              <div class="form-tip">記錄設備修繕類別的計畫排程及費用預算進行維護修繕計畫管理</div>
            </div>
            <el-table class="planList" :data="planList" empty-text="目前尚無資料">
              <el-table-column prop="price" label="購置金額" />
              <el-table-column prop="price" label="購買日期" />
              <el-table-column prop="price" label="耐用年限" />
              <el-table-column prop="price" label="修繕類別" />
              <el-table-column prop="price" label="修繕類別" />
              <el-table-column prop="price" label="修繕計畫內容" min-width="105" />
              <el-table-column prop="price" label="修繕週期(年)" min-width="100" />
              <el-table-column prop="price" label="頻次" />
              <el-table-column prop="price" label="費用預算/次" min-width="100" />
              <el-table-column prop="price" label="預估長期修繕金額" />
            </el-table>
            <div class="plan-total">
              預估長期修繕總金額：
            </div>
          </template> -->
          <div class="form-title-wrap">
            <div class="form-title">
              負責廠商
            </div>
            <div class="form-tip">
              記錄銷售/維養廠商資料
            </div>
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="負責廠商">
                <el-select
                  v-model="assetData.SupplierId"
                  filterable
                  placeholder="請輸入負責廠商"
                  :disabled="pageType === 'view'"
                >
                  <el-option
                    v-for="(item, index) in supplierList"
                    :key="index"
                    :label="item.SupplierName"
                    :value="item.SupplierId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="聯絡人">
                <el-input
                  v-model="selectedSupplier.ContactName"
                  placeholder="請輸入聯絡人"
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="聯絡電話">
                <el-input
                  v-model="selectedSupplier.SupplierTel"
                  placeholder="請輸入聯絡電話"
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手機">
                <el-input
                  v-model="selectedSupplier.SupplierPhone"
                  placeholder="請輸入手機"
                  disabled
                />
              </el-form-item>
            </el-col>
          </el-row>
          <div class="form-title-wrap">
            <div class="form-title">
              設備檔案
            </div>
            <div class="form-tip">
              管理設備使用管理辦法、檢查技術規範、操作手冊、保固卡資料
            </div>
          </div>
          <el-form-item label="附加檔案">
            <div
              v-if="pageType === 'view'"
              class="file-wrap"
            >
              <div
                v-for="(file, file_ind) in attachment.Files"
                :key="file_ind"
                class="file"
                @click="downloadFile(file.uploadUrl)"
              >
                <div class="fileName">
                  {{ `檔案${file_ind+1}` }}
                </div>
              </div>
            </div>
            <file
              v-else
              type="file"
              :filearray="attachment.Files"
              name="file"
              :quantity="3"
              @on-fileArray-change="FilesChange"
            />
          </el-form-item>
          <el-form-item label="附加圖片">
            <div
              v-if="pageType === 'view'"
              class="file-wrap"
            >
              <div
                v-for="(image, imageIndex) in attachment.ImageFiles"
                :key="imageIndex"
                class="file"
                :style="{ backgroundImage: `url(${image.uploadUrl })` }"
                @click="index = imageIndex"
              />
            </div>
            <file
              v-else
              v-model="attachment.ImageFiles"
              type="img"
              name="img"
              :filearray="attachment.ImageFiles"
              :quantity="10"
              @on-fileArray-change="ImageFilesChange"
            />
          </el-form-item>
        </el-form>
      </div>
      <div
        v-if="pageType !== 'view'"
        class="bottomControl"
      >
        <el-button
          round
          @click="$router.push({name:'assetList'})"
        >
          取消
        </el-button>
        <el-button
          type="primary"
          :disabled="isDisable"
          round
          @click="SubAssetData"
        >
          送出
        </el-button>
      </div>
    </div>
    <CoolLightBox
      :items="lightboxImage"
      :index="index"
      :slideshow="false"
      @close="index = null"
    />
  </div>
</template>
<script>
import file from '@/components/File'
export default {
  components: {
    file
  },
  data () {
    return {
      pageType: this.$route.query.pageType,
      assetData: {
        AssetSn: null,
        AssetName: null,
        CategoryId: null,
        StatusId: null,
        BrandName: null,
        ModelNo: null,
        ProductSn: null,
        AreaId: null,
        PurchaseAmount: null,
        PurchaseDate: null,
        UsefulLife: null,
        WarrantyExpirationDate: null,
        SupplierId: null
      },
      attachment: {
        Files: [],
        ImageFiles: []
      },
      originAttachment: {
        Files: [],
        ImageFiles: []
      },
      deleteAttachments: [],
      rule: {
        AssetName: [
          { required: true, message: '欄位不可為空', trigger: 'blur' }
        ],
        StatusId: [
          { required: true, message: '欄位不可為空', trigger: 'blur' }
        ]
      },
      isDisable: false,
      planList: [],
      categoryList: [],
      statusList: [],
      areaList: [],
      supplierList: [],
      selectedCategory: [],
      originalCategoryList: [],
      index: null
    }
  },
  computed: {
    selectedSupplier () {
      return this.supplierList.find(item => item.SupplierId === this.assetData.SupplierId) || {}
    },
    lightboxImage () {
      return this.attachment.ImageFiles.map(item => item.uploadUrl)
    }
  },
  mounted () {
    const vm = this
    Promise.all([
      vm.getCategory(),
      vm.getArea(),
      vm.getStatus(),
      vm.getSupplier()
    ]).then(() => {
      vm.getAssetData()
      vm.getAttachment()
    }).catch(() => {})
  },
  methods: {
    // 取得資產類型
    getCategory () {
      apiAsset.Asset.GetCategory()
        .then(res => {
          console.log(res)
          this.originalCategoryList = res.data
          const mainCategory = this.categoryList
          this.originalCategoryList.forEach(item => {
            if (!item.ParentId) {
              mainCategory.push({
                label: item.Name,
                value: item.Id,
                children: []
              })
            }
          })
          this.originalCategoryList.forEach(item => {
            if (item.ParentId && item.Name) {
              const index = mainCategory.findIndex(mainItem => mainItem.value === item.ParentId)
              mainCategory[index].children.push({
                label: item.Name,
                value: item.Id
              })
            }
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 取得社區位置
    getArea () {
      return new Promise((resolve, reject) => {
        apiAsset.Asset.GetAreas()
          .then(res => {
            console.log(res)
            this.areaList = res.data
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject(new Error('取得區域資料失敗'))
          })
      })
    },
    // 取得資產狀態
    getStatus () {
      return new Promise((resolve, reject) => {
        apiAsset.Asset.GetStatus()
          .then(res => {
            console.log(res)
            this.statusList = res.data
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject(new Error('取得資產狀態失敗'))
          })
      })
    },
    // 取得廠商
    getSupplier () {
      return new Promise((resolve, reject) => {
        apiAsset.Asset.GetSuppliers()
          .then(res => {
            console.log(res)
            this.supplierList = res.data
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject(new Error('取得廠商資料失敗'))
          })
      })
    },
    // 取得設備詳細資料
    getAssetData () {
      if (!this.$route.query.assetId) return
      const params = {
        AssetId: this.$route.query.assetId
      }
      apiAsset.Asset.GetAsset(params)
        .then(res => {
          console.log(res)
          const { CategoryId, ...others } = res.data
          this.assetData = others
          this.selectedCategory = []
          const category = this.originalCategoryList.find(item => item.Id === CategoryId)
          if (!category) return
          if (category.ParentId) {
            this.selectedCategory = [category.ParentId, CategoryId]
          } else {
            this.selectedCategory = [CategoryId]
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getAttachment () {
      if (!this.$route.query.assetId) return
      const params = {
        AssetId: this.$route.query.assetId
      }
      apiAsset.Asset.GetAttachments(params)
        .then(res => {
          console.log(res)
          res.data.Files.forEach(item => {
            this.attachment.Files.push({
              type: 'file',
              id: item.FileId,
              file: '',
              uploadUrl: item.FileUrl
            })
            this.originAttachment.Files.push(item.FileId)
          })
          res.data.Pics.forEach(item => {
            axios(item.FileUrl, {
              method: 'GET',
              headers: { KingnetAuth: `Cookies ${this.$getCookie('comLoginToken').replace('token=', '')}` },
              responseType: 'blob'
            }).then(res => {
              const vm = this
              const url = (new Blob([res.data]))
              convertFile(url)
                .then(data => {
                  vm.attachment.ImageFiles.push({
                    type: 'img',
                    id: item.FileId,
                    file: '',
                    uploadUrl: data,
                    BS64: ''
                  })
                  vm.originAttachment.ImageFiles.push(item.FileId)
                })
                .catch(err => console.log(err))
              function convertFile (file) {
                return new Promise((resolve, reject) => {
                  const reader = new FileReader()
                  reader.onload = () => { resolve(reader.result) }
                  reader.onerror = () => { reject(reader.error) }
                  reader.readAsDataURL(file)
                })
              }
            }).catch(error => {
              console.log(error)
            })
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 檔案的components回釣函式
    FilesChange (val) {
      this.attachment.Files = val
    },
    // 檔案的components回釣函式
    ImageFilesChange (val) {
      this.attachment.ImageFiles = val
    },
    // 送出按鈕
    SubAssetData () {
      this.isDisable = true
      this.$refs.assetData.validate((valid) => {
        if (valid) {
          this.DeleteChangedFiles()
          this.FileUpload()
        } else {
          window.scrollTo(0, 0)
        }
      })
      setTimeout(() => {
        this.isDisable = false
      }, 1000)
    },
    // 上傳檔案&紀錄
    FileUpload () {
      const vobj = this
      const totalCount = { img: vobj.attachment.ImageFiles.length, file: vobj.attachment.Files.length }
      const uploadStatus = { img: { success: 0, error: 0 }, file: { success: 0, error: 0 } }
      const loadingWrap = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      // eslint-disable-next-line eqeqeq
      if (totalCount.img + totalCount.file == 0 || !vobj.$route.query.assetId) {
        document.querySelector('.el-loading-text').innerHTML = '正在寫入資料中請稍後'
      } else {
        document.querySelector('.el-loading-text').innerHTML = `檔案已上傳${uploadStatus.img.success + uploadStatus.img.error + uploadStatus.file.success + uploadStatus.file.error}筆，共${totalCount.img + totalCount.file}筆`
      }

      if (!vobj.$route.query.assetId) {
        sand_api()
      } else {
        upload_image()
      }
      // 上傳圖片
      function upload_image () {
        // eslint-disable-next-line eqeqeq
        if (vobj.attachment.ImageFiles.length != 0) {
          document.querySelector('.el-loading-text').innerHTML = `檔案已上傳${uploadStatus.img.success + uploadStatus.img.error + uploadStatus.file.success + uploadStatus.file.error}筆，共${totalCount.img + totalCount.file}筆`
          const now_index = uploadStatus.img.success + uploadStatus.img.error
          // eslint-disable-next-line eqeqeq
          if (vobj.attachment.ImageFiles[now_index].file == '') {
            uploadStatus.img.success += 1
            next()
          } else {
            SandUpdateFileApi(vobj.attachment.ImageFiles[now_index].file, 'Picture', res => {
              // eslint-disable-next-line eqeqeq
              if (res != 'error') {
                vobj.attachment.ImageFiles[now_index].uploadUrl = res.data[0].FileUrl
                uploadStatus.img.success += 1
                next()
              }
            })
          }
          function next () {
            // Progress_add += 100 / (totalCount.img+totalCount.file)
            // vobj.Progress.setProgress(Progress_add)
            // eslint-disable-next-line eqeqeq
            if (totalCount.img == uploadStatus.img.success + uploadStatus.img.error) {
              upload_file()
            } else {
              upload_image()
            }
          }
        } else {
          upload_file()
        }
      }
      // 上傳檔案
      function upload_file () {
        // eslint-disable-next-line eqeqeq
        if (vobj.attachment.Files.length != 0) {
          document.querySelector('.el-loading-text').innerHTML = `檔案已上傳${uploadStatus.img.success + uploadStatus.img.error + uploadStatus.file.success + uploadStatus.file.error}筆，共${totalCount.img + totalCount.file}筆`
          const now_index = uploadStatus.file.success + uploadStatus.file.error

          // eslint-disable-next-line eqeqeq
          if (vobj.attachment.Files[now_index].file == '') {
            uploadStatus.file.success += 1
            next()
          } else {
            SandUpdateFileApi(vobj.attachment.Files[now_index].file, 'File', res => {
              // eslint-disable-next-line eqeqeq
              if (res != 'error') {
                vobj.attachment.Files[now_index].uploadUrl = res.data[0].FileUrl
                uploadStatus.file.success += 1
                next()
              }
            })
          }

          function next () {
            document.querySelector('.el-loading-text').innerHTML = `檔案已上傳${uploadStatus.img.success + uploadStatus.img.error + uploadStatus.file.success + uploadStatus.file.error}筆，共${totalCount.img + totalCount.file}筆`
            // eslint-disable-next-line eqeqeq
            if (totalCount.file == uploadStatus.file.success + uploadStatus.file.error) {
              document.querySelector('.el-loading-text').innerHTML = '正在寫入資料中請稍後...'
              sand_api()
            } else {
              upload_file()
            }
          }
        } else {
          sand_api()
        }
      }
      // 新增、編輯資產設備
      function sand_api () {
        if (!vobj.$route.query.assetId) {
          const paramsObj = Object.keys(vobj.assetData)
          const formData = new FormData()
          paramsObj.forEach(item => {
            if (vobj.assetData[item] !== null) {
              formData.append(item, vobj.assetData[item])
            }
          })
          if (vobj.selectedCategory.length) {
            formData.append('CategoryId', vobj.selectedCategory[1] ? vobj.selectedCategory[1] : vobj.selectedCategory[0])
          }
          vobj.attachment.Files.forEach(item => {
            formData.append('Files', item.file)
          })
          vobj.attachment.ImageFiles.forEach(item => {
            formData.append('PictureFiles', item.file)
          })
          apiAsset.Asset.PostAsset(formData)
            .then(res => {
              console.log(res)
              loadingWrap.close()
              vobj.$alert('資產設備新增成功。', '', {
                confirmButtonText: '確定',
                callback: () => {
                  vobj.$router.push({ name: 'assetList' })
                }
              })
            })
            .catch(err => {
              console.log('err', err)
              loadingWrap.close()
              vobj.$alert('資產設備新增失敗', '', {
                confirmButtonText: '確定',
                callback: action => {}
              })
            })
        } else {
          const params = {
            ...vobj.assetData,
            AssetId: vobj.$route.query.assetId,
            CategoryId: vobj.selectedCategory[1] ? vobj.selectedCategory[1] : vobj.selectedCategory[0]
          }
          apiAsset.Asset.PutAsset(params)
            .then(res => {
              console.log(res)
              loadingWrap.close()
              vobj.$alert('資產設備更新成功。', '', {
                confirmButtonText: '確定',
                callback: () => {
                  vobj.$router.push({ name: 'assetList' })
                }
              })
            })
            .catch(err => {
              console.log('err', err)
              loadingWrap.close()
              vobj.$alert('資產設備更新失敗', '', {
                confirmButtonText: '確定',
                callback: action => {}
              })
            })
        }
      }
      // 處理檔案上傳API
      function SandUpdateFileApi (FileData, FileType, callback) {
        if (!vobj.$route.query.assetId) return
        const uploadFormData = new FormData()
        uploadFormData.append('FileType', FileType)
        uploadFormData.append('File', FileData)
        const params = {
          AssetId: vobj.$route.query.assetId,
          FormData: uploadFormData
        }
        apiAsset.Asset.PostAttachments(params)
          .then(res => {
            console.log(res)
            callback(res)
          })
          .catch(err => {
            loadingWrap.close()
            vobj.$message({
              message: '上傳過程發生異常，請重新再[送出]一次',
              type: 'warning'
            })
            console.log(err)
            callback('error')
          })
      }
    },
    // 刪除有異動的檔案
    DeleteChangedFiles () {
      const vobj = this
      if (!vobj.$route.query.assetId) return
      const uploadFileIds = vobj.attachment.Files.map(item => item.id)
      const uploadImageFileIds = vobj.attachment.ImageFiles.map(item => item.id)
      vobj.originAttachment.Files.forEach(item => {
        const index = uploadFileIds.indexOf(item)
        if (index === -1) {
          vobj.deleteAttachments.push(item)
        } else if (vobj.attachment.Files[index].file) {
          vobj.deleteAttachments.push(item)
        }
      })
      vobj.originAttachment.ImageFiles.forEach(item => {
        const index = uploadImageFileIds.indexOf(item)
        if (index === -1) {
          vobj.deleteAttachments.push(item)
        } else if (vobj.attachment.ImageFiles[index].file) {
          vobj.deleteAttachments.push(item)
        }
      })
      if (!vobj.deleteAttachments.length) return
      const params = {
        AssetId: vobj.$route.query.assetId,
        AttachmentIds: vobj.deleteAttachments
      }
      apiAsset.Asset.DeleteAttachments(params)
        .then(res => {
          console.log(res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    downloadFile (fileUrl) {
      axios(fileUrl, {
        method: 'GET',
        headers: { KingnetAuth: `Cookies ${this.$getCookie('comLoginToken').replace('token=', '')}` },
        responseType: 'blob'
      }).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const fileName = fileUrl.split('/')[fileUrl.split('/').length - 1]
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>
<style lang="sass" scoped>
#assetEdit
  padding: 50px 0
  ::v-deep .el-dialog
    +basicDialog
    p
      line-height: 25px
  .main
    min-width: 1140px
    max-width: 1140px
    margin: 0 auto
    padding: 30px
    color: $mainFontColor
    background-color: #fff
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
    border-radius: $pageBorderRadius
    box-sizing: border-box
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      .title
        font-weight: bold
        font-size: map-get($fontSize,xx-large)
        color: $mainFontColor
        text-align: left
      .tips
        color: #f00
      .tip
        font-size: map-get($fontSize,small)
        color: $subFontColor
  ::v-deep .el-form.list
    // +basicFormInsert
    width: 100%
    .el-form-item
      &.Interval
        width: 50%
        padding: 5px
      &.half
        width: 50%
      &__content
        flex: 1
        // max-width: 400px
        .file-wrap
          flex-wrap: wrap
        .el-select,.el-date-editor
          width: 100%
  .blockWrap
    text-align: left
    display: inline-flex
    flex-wrap: wrap
    width: 100%
    margin-bottom: 30px
    padding: 10px 180px 0 180px
    box-sizing: border-box
    .form-title-wrap
      width: 100%
      padding: 15px 0
      background-color: $minorColor
      .form-title
        font-weight: bold
        font-size: map-get($fontSize,large)
        text-decoration: underline
        margin-bottom: 5px
  .bottomControl
    text-align: center
    border-top: solid 1px $borderDark1
    padding: 30px 0 0
  .planList
    margin: 20px 0
    ::v-deep .el-table
      +basicTable
  .plan-total
    text-align: right
    margin-bottom: 20px
    font-weight: bold
  .file-wrap
    display: flex
    flex-wrap: wrap
    .file
      width: 150px
      height: 150px
      border: 1px solid #ccc
      color: #666
      border-radius: 4px
      cursor: pointer
      margin: 10px
      position: relative
      overflow: hidden
      background-position: center
      background-size: cover
      &:hover
        color: #333
        border: 1px solid #aaa
        box-shadow: inset 0 1px 2px -1px rgba(0,0,0,.075), 0 0 8px rgba(120,120,120,.5)
        transition: .4s
        .optionBtn-wrap
          bottom: 0
      i
        font-size: 60px
      .fileName
        font-size: 17px
        font-weight: 700
        width: 100%
        height: 100%
        line-height: 150px
        text-align: center
      .bg-img
        height: 100%
        width: 100%
        background-position: center
        background-size: cover
</style>
